//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Assemblies.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/FileNew.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ComponentCam",1,0],[0,"ComponentOrigin",1,0],[0,"Csys",1,"CoordinateSystem",0],[0,"DefiningObjectsAdded",1,0],[0,"LayerNumber",1,0],[0,"LayerOption",1,0],[0,"NewComponentName",1,0],[0,"NewFile",1,"FileNew",0],[1,"ObjectForNewComponent",0,"SelectDisplayableObjectList",0],[0,"OriginalObjectsDeleted",1,0],[0,"ReferenceSet",1,0],[0,"ReferenceSetName",1,0]],[],[]];
SPLM.Assemblies.CreateNewComponentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Assemblies.CreateNewComponentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Assemblies.CreateNewComponentBuilder.ComponentReferenceSetType = Object.freeze({
    "Model" : "Model", "EntirePartOnly" : "EntirePartOnly", "Other" : "Other"});

SPLM.Assemblies.CreateNewComponentBuilder.ComponentLayerOptionType = Object.freeze({
    "Original" : "Original", "Work" : "Work", "AsSpecified" : "AsSpecified"});

SPLM.Assemblies.CreateNewComponentBuilder.ComponentOriginType = Object.freeze({
    "Wcs" : "Wcs", "Absolute" : "Absolute", "Newcsys" : "Newcsys"});

SPLM.Assemblies.CreateNewComponentBuilder.ComponentCamType = Object.freeze({
    "Target" : "Target", "Resource" : "Resource", "Workpiece" : "Workpiece"});

export default SPLM;